import { render, staticRenderFns } from "./SalesData.vue?vue&type=template&id=6a7d2712&scoped=true&"
import script from "./SalesData.vue?vue&type=script&lang=js&"
export * from "./SalesData.vue?vue&type=script&lang=js&"
import style0 from "./SalesData.vue?vue&type=style&index=0&id=6a7d2712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7d2712",
  null
  
)

export default component.exports